import { QUERY_KEY_PREFIXES } from 'dpl/shared/fetching/utils/constants';

export function contactEditDefinition(
  breederProfileId,
  contactType,
  dogId,
  breedId
) {
  const params = { dog_id: dogId };
  if (breedId) params.breed_id = breedId;
  return {
    prefix: QUERY_KEY_PREFIXES.CONTACT_EDIT,
    params,
    url: `/api/breeder_profiles/${breederProfileId}/contacts/${contactType}/edit.json`,
    enabled: Boolean(breederProfileId) && Boolean(contactType)
  };
}

export function sendVerificationCodeMutationDefinition(verification) {
  return {
    url: `/api/users/verifications/send_code.json`,
    method: 'POST',
    params: { verification }
  };
}

export function enhancedConversionDataDefinition() {
  return {
    url: `/api/me/enhanced_conversion_data.json`,
    enabled: false
  };
}
